<template>
  <div>
    <!-- 头部简单信息 -->
    <div class="detail-head">
      <div class="avator">
        <device-image
          :name="device.name"
          :width="100"
          :height="100"
        ></device-image>
      </div>
      <div class="info-keys">
        <div>设备名称:</div>
        <div style="padding: 16px 0">设备型号:</div>
      </div>
      <div class="info-values">
        <div>{{ device.device_name || "-" }}</div>
        <div style="padding: 18px 0">
          {{ device.name || "-" }}
        </div>
      </div>
    </div>
    <div class="app-right-main" style="padding: 20px">
      <!-- <div class="project">
        <el-button type="primary" @click="goProject" class="add-button">
          项目管理
        </el-button>
      </div> -->
      <el-button
        type="primary"
        v-permission="'ota_project_add'"
        @click="addProject"
        class="add-button"
        size="small"
        icon="el-icon-plus"
      >
        添加项目
      </el-button>
      <div class="app-right-table-content" style="margin-bottom: 20px">
        <el-table :data="projectList" stripe size="small" style="width: 100%">
          <el-table-column
            v-for="item in this.projectConfig.PROJECT_HEADER"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
          >
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click.native.prevent="showOtaList(scope.row)"
                >查看
              </el-button>
              <el-button
                type="text"
                v-permission="'ota_add'"
                size="small"
                @click.native.prevent="showAddConfig(scope.row)"
                >添加
              </el-button>
              <el-button
                v-permission="'ota_edit'"
                type="text"
                size="small"
                @click.native.prevent="editProject(scope.$index, projectList)"
                >编辑
              </el-button>
              <el-button
                v-permission="'ota_dev_user'"
                type="text"
                size="small"
                @click.native.prevent="
                  confProject = scope.row;
                  confVisible = true;
                "
                >设备与用户
              </el-button>
              <!--            <el-button type="text" size="small" @click.native.prevent="deleteProject(scope.$index, projectList)">删除-->
              <!--            </el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <ota-user-conf
        :visible="confVisible"
        :project="confProject"
        @onClose="confVisible = false"
      ></ota-user-conf>
      <el-dialog
        title="添加项目"
        :visible.sync="projectDialogVisible"
        @close="closeOtaDialog"
      >
        <add-project-form
          :edit-project="editProjectForm"
          @clickCancel="closeOtaDialog"
          @clickConfirm="confirmAddProjectAction"
        ></add-project-form>
      </el-dialog>

      <el-dialog
        title="查看OTA配置"
        :visible.sync="otaListDialogVisible"
        width="1000px"
        @close="closeOtaDialog"
        :append-to-body="true"
      >
        <ota-list
          :socTypeList="socTypeList"
          :project="selectProject"
        ></ota-list>
      </el-dialog>

      <el-dialog
        title="添加OTA配置"
        :visible.sync="otaDialogVisible"
        @close="closeOtaDialog"
        :append-to-body="true"
      >
        <add-ota-form
          :socTypeList="socTypeList"
          :project="selectProject"
          :dialog-visible="otaDialogVisible"
          @clickCancel="closeOtaDialog"
          @successCreateOta="successCreateOtaAction"
        ></add-ota-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  projectEdit,
  getProjectList,
  deleteProject,
} from "../../api/projectApi";
import { optionsList } from "../../api/optionsApi";
import { handleResponse } from "../../utils/response";

import AddOtaForm from "./addOTAForm";
import AddProjectForm from "./addProjectForm";
import OtaList from "./OtaList";
import DeviceImage from "./../deviceImage";
import OtaUserConf from "./otaUserConf.vue";

export default {
  name: "Project",

  components: {
    AddProjectForm,
    AddOtaForm,
    OtaList,
    DeviceImage,
    OtaUserConf,
  },
  mounted() {
    console.log("--------------ota mounted---------------");
  },
  created() {
    const id = this.$route.query.id;
    optionsList({ type: 1 }).then((res) => {
      handleResponse(
        res,
        (data) => {
          this.device = data.list?.find((d) => d._id === id) || {};
          this.getProjectList(1, 100, this.device.name);
        },
        (error) => {}
      );
    });
  },
  computed: {
    checkFlag() {
      //查看OTA权限控制
      return (
        this.$store.state.userInfo.permissions.includes("retriveOTA") ||
        this.$store.getters.isAdmin
      );
    },
    addProjectFlag() {
      //添加项目权限控制
      return (
        this.$store.state.userInfo.permissions.includes("addProject") ||
        this.$store.getters.isAdmin
      );
    },
    addFlag() {
      //添加OTA权限控制
      return (
        this.$store.state.userInfo.permissions.includes("addOTA") ||
        this.$store.getters.isAdmin
      );
    },
    editFlag() {
      //编辑OTA权限控制
      return (
        this.$store.state.userInfo.permissions.includes("updateOTA") ||
        this.$store.getters.isAdmin
      );
    },
  },
  methods: {
    // 跳转项目管理
    goProject() {
      this.$router.push("/project");
    },

    /**
     * 获取项目列表
     */
    getProjectList(page, size, name) {
      getProjectList(page, size, name).then((response) => {
        handleResponse(
          response,
          (data) => {
            console.log("ota 项目数据------", data);
            this.projectList = (data.list || []).map((d) => {
              if (d.otaVersion) {
                const v = d.otaVersion;
                if (d.deviceName == "Y006") {
                  d.otaVersion = `${v}【${("00000000" + v)
                    .substr(-8)
                    .split("")
                    .map((s, i) =>
                      i == 0 ? "00" + s : i == 1 || i == 3 ? "0" + s : s
                    )
                    .join("")
                    .match(new RegExp(".{1,3}", "g"))
                    .map((s) => parseInt("0x" + s))
                    .join(".")}】`;
                }
                if (d.deviceName == "Y001S") {
                  d.otaVersion = `${v}【${("00000000" + v)
                    .substr(-8)
                    .match(new RegExp(".{1,2}", "g"))
                    .map((s) => parseInt("0x" + s))
                    .join(".")}】`;
                }
              }
              return d;
            });

            console.log("projectList类型-------" + typeof this.projectList);
            console.log(this.projectList);
          },
          (error) => {}
        );
      });
    },
    /**
     * 上传OTA文件
     */
    uploadOtaFile() {
      this.otaDialogVisible = true;
      this.selectProject = { id: -1 };
    },

    //添加项目点击"确定"操作
    confirmAddProjectAction(e) {
      this.projectDialogVisible = false;
      console.log("---------------添加项目---------------");
      projectEdit({ ...e, deviceName: this.device.name }).then((res) => {
        handleResponse(
          res,
          (data) => {
            console.log("添加项目-------" + data);
            this.getProjectList(1, 100, this.device.name);
          },
          (error) => {}
        );
      });
    },
    /**
     * 添加项目
     */
    addProject() {
      this.editProjectForm = {};
      this.projectDialogVisible = true;
    },
    /**
     * 关闭弹出框 统一操作
     */
    closeOtaDialog() {
      this.editProjectForm = {};
      this.selectProject = { id: -1 };
      this.projectDialogVisible = false;
      this.otaDialogVisible = false;
    },
    //添加OTA点击"确定"操作
    successCreateOtaAction() {
      this.otaDialogVisible = false;
      this.getProjectList(1, 100, this.device.name);
    },

    showAddConfig(row) {
      this.selectProject = { ...row };
      this.otaDialogVisible = true;
    },
    /**
     * 删除项目
     * @param index
     * @param rows
     */
    deleteProject(index, rows) {
      let id = this.projectList[index]["id"];
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteProject(id).then((response) => {
            handleResponse(
              response,
              (data) => {
                this.getProjectList(1, 100, this.device.name);
              },
              (error) => {}
            );
          });
        })
        .catch(() => {});
    },
    editProject(index, rows) {
      this.editProjectForm = this.projectList[index];
      this.projectDialogVisible = true;
    },
    showOtaList(row) {
      this.$router.push({
        path: "/otaList",
        query: { id: row.id, did: this.device._id },
      });
      // this.otaListDialogVisible = true;
      // this.selectProject = { ...row };
    },
  },
  data() {
    return {
      confVisible: false,
      confProject: {},
      device: {},
      selectProject: { id: -1 },
      formLabelWidth: "100px",
      projectDialogVisible: false,
      otaDialogVisible: false,
      otaListDialogVisible: false,
      projectList: [],
      editProjectForm: {},
      socTypeList: [
        {
          name: "01s",
          value: "0×00000001",
        },
        {
          name: "06s",
          value: "0×00000002",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.detail-head {
  box-sizing: border-box;
  display: flex;
  width: 100%;
  height: 174px;
  padding: 40px;
  margin-bottom: 20px;
  background-color: #fff;
  .avatorImg {
    width: 100px;
    height: 100px;
  }
  .info-keys {
    text-align: right;
    width: 156px;
    color: #86909c;
  }
  .info-values {
    padding-left: 16px;
    .detail-edit {
      color: #165dff;
      padding-left: 16px;
    }
  }
}

.project {
  padding: 20px 20px 30px;
}

.add-button {
  margin-left: 20px;
  min-width: 100px;
}

.header-content {
  margin-top: 20px;
  margin-left: 20px;
  margin-right: 30px;
  min-width: 100px;
  height: 100%;
}
</style>
